import { Component, ElementRef, HostListener, inject, OnInit, signal, ViewChild } from '@angular/core';
import { InternalAuthService, UtilityService } from '@eforall/common';
import { AppDataService, StaticDataService } from 'services';
import { DashboardToolbarPart } from './dashboard-toolbar-part/dashboard-toolbar.part';
import { DashboardPageService } from './dashboard.page.service';
import { VegaPart } from './display-types/vega/display/vega.part';
import { QuickFiltersBarPart } from './quick-filters-bar-part/quick-filters-bar.part';
import { QuickFiltersPanelPart } from './quick-filters-panel-part/quick-filters-panel.part';

@Component({
	selector: 'dashboard-page',
	imports: [DashboardToolbarPart, QuickFiltersBarPart, QuickFiltersPanelPart, VegaPart],
	templateUrl: './dashboard.page.html',
	styleUrl: './dashboard.page.scss',
	host: {
		'[class.dom-ready]': 'pageLoaded()',
		'[class.show-quick-filters-bar]': 'pageService.showQuickFiltersBar()',
		'[class.show-quick-filters-panel]': 'pageService.showQuickFiltersPanel()',
	}
})
export class DashboardPage implements OnInit {

	@ViewChild('menuBtn') menuBtn!: ElementRef;
	@ViewChild('menu') menu!: ElementRef;

	private auth = inject(InternalAuthService);
	private appData = inject(AppDataService);
	private staticData = inject(StaticDataService);
	private util = inject(UtilityService);
	public pageService = inject(DashboardPageService);

	public pageLoaded = signal(false);

	ngOnInit() {
		setTimeout(() => { this.pageLoaded.set(true) }, 100);
	}

	/**
	 * Whether the hamburger menu is currently visible.  The html uses an @if to
	 * display it when set.
	 */
	public isMenuOpen = signal(false);

	toggleMenu() {
		this.isMenuOpen.set(!this.isMenuOpen());
	}



	/**
	 * Handles when the user clicks the Sign out menu option in the hanburger menu.
	 */
	signOut() {
		this.auth.signOut();
		this.isMenuOpen.set(false);
	}


	/**
	 * Listen for document clicks to determine if the hamburger menu is open
	 * and needs to be closed, because the user clicked outside the menu.
	 */
	@HostListener('document:click', ['$event'])
	documentClick(event: MouseEvent) {

		if (!this.isMenuOpen()) return;

		const clickedToggle = this.menuBtn.nativeElement.contains(event.target);
		const clickedInsideMenu = this.menu?.nativeElement.contains(event.target);

		if (!clickedToggle && !clickedInsideMenu) this.isMenuOpen.set(false);
	}



	//
	// Drop list code
	//

	/**
	 * This mediaQuery signal is used to hide the droplist on small screens.
	 */
	public readonly isSmall = this.util.mediaQuery.createSignal('(max-width: 652px)');



}
